import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ArticleTable from '@accounting/components/tables/article-table/article-table.vue';

@Component({
  name: 'bpc-pos-checkout',
  components: {
    'bpc-article-table': ArticleTable,
  },
})
export default class PosArticlesCheckout extends Vue {
  get currentTicket() {
    return this.$store.getters['pos/currentTicket'];
  }

  get showArticles(): boolean {
    return this.currentTicket && this.currentTicket.status != 'paid';
  }
}
